// extracted by mini-css-extract-plugin
export default {"overlay":"Mw-z","bodyOpen":"Nw-z","content":"Ow-z","header":"Pw-z","close":"Qw-z","closeNoHeading":"Rw-z"};